import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Sublinks from "../components/sublinks"
import Infolinia from "../components/infolinia"
import BackgroundImage from "gatsby-background-image"

import '../sass/main.scss'

const query = graphql`
  {
    step1: file(relativePath: { eq: "steps/step1en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    step2: file(relativePath: { eq: "steps/step2en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    step3: file(relativePath: { eq: "steps/step3en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    step4: file(relativePath: { eq: "steps/step4en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    step5: file(relativePath: { eq: "steps/step5en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    step6: file(relativePath: { eq: "steps/step6en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    step7: file(relativePath: { eq: "steps/step7en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    step8: file(relativePath: { eq: "steps/step8en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    step9: file(relativePath: { eq: "steps/step9en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    step10: file(relativePath: { eq: "steps/step10en.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    fotka: file(relativePath: { eq: "steps/app-bg.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const JakDziala = () => {
    const data = useStaticQuery(query)

  return (
    <Layout>
      <SEO title="ORLEN | How ORLEN Charge works" />
      <Sublinks />

      <BackgroundImage
        Tag="section"
        className={`sub-visual sub-visual-ladowarki mb-5`}
        fluid={data.fotka.childImageSharp.fluid}
        backgroundColor={`#000`}
      >
        <div className="bg-overlay"></div>
        <div
          className="visual-content col-md-8 ie11animfix"
          data-sal="slide-up"
          data-sal-delay="500"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          <div className="title text-center">HOW ORLEN CHARGE WORKS</div>
        </div>
        <Infolinia customStyle="d-none d-md-flex js-infolinia" />
      </BackgroundImage>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">1</div>
              <div className="step-desc">
                Download our ORLEN Charge mobile app from the{" "}
                <a
                  href="https://apps.apple.com/us/app/orlen-charge/id1478111353"
                  target="_blank"
                  rel="noreferrer"
                  title="zainstaluj aplikację z App Store"
                >
                  AppStore
                </a>{" "}
                or&nbsp;
                <a
                  href="https://play.google.com/store/apps/details?id=pl.orlen.charge"
                  target="_blank"
                  rel="noreferrer"
                  title="zainstaluj aplikację z Google Play"
                >
                  Google Play
                </a>
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step1.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>

          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">2</div>
              <div className="step-desc">
                Enter your details to register in the app
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step2.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">3</div>
              <div className="step-desc">
                Go to the My Car tab and enter your car details
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step3.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">4</div>
              <div className="step-desc">
                Use filters to find a charging station suitable for your car.
                You can also use the map to locate a charging station
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step4.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">5</div>
              <div className="step-desc">
                Before a charging session starts, add your payment card details
                under the Payment tab and click pay.
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step5.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">6</div>
              <div className="step-desc">
                Select a connector, check pricing and start your charging
                session.
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step6.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">7</div>
              <div className="step-desc">
                Once the charging session has started, you can check charging
                status, power and energy charged
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step7.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">8</div>
              <div className="step-desc">
                By clicking the Charging History tab you can view your previous
                charging sessions
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step8.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">9</div>
              <div className="step-desc">
                Go to the Invoices tab to check costs and download invoices for
                completed charging sessions.
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step9.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between mb-3 mb-xl-5">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="step-number">10</div>
              <div className="step-desc">
                If necessary, you can contact us by calling the helpline or
                using the form available from opinie.orlen.pl
              </div>
            </div>
            <div className="text-center">
              <Image
                fluid={data.step10.childImageSharp.fluid}
                className="step-fotka"
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default JakDziala



